import useCommitVersionLogger from 'features/app-version/UseCommitVersionLogger'
import useReloadTracker from 'features/reload-tracker/ReloadTracker'

export default function HighLevelEventsTracker() {
  useCommitVersionLogger()
  useReloadTracker()

  return null
}
